module.exports = "<!-- Cancel Reservation Button -->\n<div class='hThree cancel-res-button themeBG text-center' [ngClass]=\"{'disabled-button':enabled === false}\" (click)=\"onButtonClick()\" data-slnm-ihg='cancelReservationButtonSID' [innerText]=\"messages['actions.cancel.confirm.label']\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/cancel-res-button/cancel-res-button.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/cancel-res-button/cancel-res-button.component.html
// module chunks = 0